import React from 'react';
import PropTypes from 'prop-types';
import MarkushValue from '@Components/Results/substances/tables/markush/MarkushValue';
import StructurePreview from '@Components/Results/structure/StructurePreview';

function MarkushGroup({ uid, group }) {
  return (
    <tbody id={`${uid}-${group.label}`}>
      {Array.isArray(group.members) &&
        group.members.map((member, index) => (
          <tr key={member?.id || index}>
            <td>{index === 0 ? group.label : ''}</td>
            {!member?.path && (
              <td>
                <MarkushValue value={member?.data?.value} uid={uid} />
              </td>
            )}
            {member?.path && (
              <td className="markush-picture">
                <StructurePreview markushPreview={member.path} />
              </td>
            )}
            <td>{member?.data?.size}</td>
            <td>{member?.data?.attributes}</td>
            <td>
              {member?.data && (
                <MarkushValue value={member.data.substitutedBy} uid={uid} />
              )}
            </td>
            <td>{member?.data?.frequency}</td>
          </tr>
        ))}
    </tbody>
  );
}

MarkushGroup.propTypes = {
  uid: PropTypes.string.isRequired,
  group: PropTypes.object.isRequired,
};

export default MarkushGroup;
